import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import SecurityScorecardConfigListing from './SecurityScorecardConfigListing'
import SecurityScorecardCredentialsForm from './SecurityScorecardCredentialsForm'

export default function SecurityScorecardPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={SecurityScorecardCredentialsForm}
            PullConfigListingView={SecurityScorecardConfigListing}
        />
    )
}